import {
    PayloadAction,
    FeatureActionReducer,
    createFeatureReducer,
    entityListReducer
} from '../../../store/store.utils';
import {
    History,
    HistoryEvent
} from '../../../../../common/models/history.interface';
import { User } from '../../../../../common/models/user-interface';
import {
    HistoryPagination,
    HistoryState,
    initialHistoryState
} from '../history.state';
import { FilterModel } from '../history.state';

function setEventLoading(
    uiState: HistoryState['ui'],
    flag: boolean
): HistoryState['ui'] {
    return {
        ...uiState,
        historyGrid: {
            ...uiState.historyGrid,
            loading: flag
        }
    };
}

export abstract class HistoryActionReducer extends FeatureActionReducer<HistoryState> {
    protected constructor(name: string) {
        super('HistoryEvent', name);
    }
}

export class GetEventHistorySuccess
    extends HistoryActionReducer
    implements PayloadAction<History> {
    constructor(public readonly payload: History, eventId: number) {
        super('GetEventHistory Success');
        payload['eventId'] = eventId;
    }
    reduce(state: HistoryState): HistoryState {
        return {
            data: {
                ...state.data,
                history: entityListReducer<number, History>(
                    state.data.history,
                    [this.payload],
                    'eventId'
                )
            },
            ui: {
                ...setEventLoading(state.ui, false)
            }
        };
    }
}

export class GetEventHistoryRequest
    extends HistoryActionReducer
    implements PayloadAction<number> {
    constructor(public readonly payload: number) {
        super('GetEventHistory Request');
    }

    reduce(state: HistoryState): HistoryState {
        return {
            ...state,
            ui: {
                ...setEventLoading(state.ui, true)
            }
        };
    }
}

const typedReducer = createFeatureReducer(
    HistoryActionReducer,
    initialHistoryState
);

export function historyReducer(state: any, action: any) {
    return typedReducer(state, action);
}

export class GetUsersByUidRequest
    extends HistoryActionReducer
    implements PayloadAction<string[]> {
    constructor(public readonly payload: string[]) {
        super('GetUsersByUid Request');
    }

    reduce(state: HistoryState): HistoryState {
        return {
            ...state,
            ui: {
                ...setEventLoading(state.ui, true)
            }
        };
    }
}

export class GetUsersByUidSuccess
    extends HistoryActionReducer
    implements PayloadAction<User[]> {
    constructor(public readonly payload: User[]) {
        super('GetUsersByUid Success');
    }

    reduce(state: HistoryState): HistoryState {
        return {
            data: {
                ...state.data,
                users: entityListReducer<number, User>(
                    state.data.users,
                    this.payload,
                    'id'
                )
            },
            ui: {
                ...setEventLoading(state.ui, false)
            }
        };
    }
}

export class UpdateHistoryUIFilter
    extends HistoryActionReducer
    implements PayloadAction<any> {
    constructor(public readonly payload: FilterModel[]) {
        super('Set HistoryTable Filters');
    }

    reduce(state: HistoryState): HistoryState {
        return {
            data: {
                ...state.data
            },
            ui: {
                ...state.ui,
                historyGrid: {
                    ...state.ui.historyGrid,
                    filter: [...this.payload]
                }
            }
        };
    }
}

export class UpdateHistoryUIPagination
    extends HistoryActionReducer
    implements PayloadAction<any> {
    constructor(public readonly payload: HistoryPagination) {
        super('Set HistoryTablePagination ');
    }

    reduce(state: HistoryState): HistoryState {
        return {
            data: {
                ...state.data
            },
            ui: {
                ...state.ui,
                historyGrid: {
                    ...state.ui.historyGrid,
                    pagination: { ...this.payload }
                }
            }
        };
    }
}
